
jQuery( function($) {

// CHECK SIDETAB VISIBILITY
const footerTab = document.querySelector('.footer-tab');
const observer = new IntersectionObserver( (entries, observer) => {
    entries.forEach( entry => {
        $('.sidetab.fixed-tab')['fade'+ (entry.isIntersecting ? 'Out' : 'In')]()
    })
}, {threshhold: 0});
observer.observe(footerTab);

// Close form on click away
function closeOnClickAway(e) {
    if( $(e.target).closest('.sideform-content')[0] !== $('.sideform-content')[0] ) {
        $(document).off( 'click touch', closeOnClickAway);
        $('.close-form').trigger('click');
    }
}

// OPEN FORM
function openForm(e = null) {
    e?.preventDefault();

    const inputFocus = document.getElementById('newsite');

    if (inputFocus) {
        inputFocus.focus();
    }

    $('.sideform-color').addClass('show');
    $('body').css('overflow','hidden');
    setTimeout(function(){
        $('.sideform-content').addClass('show');
        $(document).on('click touch', closeOnClickAway);
    }, 500);
}
document.querySelectorAll('#contactLink, [href="#contact-form"], .tab-text, #serviceContactLink').forEach( trigger => {
    trigger.addEventListener('click', openForm);
});

// INITIAL CHOICE DIRECTION
// $('#start-form .next').on('click touch keydown', function(e){
//     // If enter/space key not pressed when a keyboard event, then ignore
//     if (
//         e.originalEvent instanceof KeyboardEvent
//         && (e.key !== "Enter" && e.key !== " ")
//     ) return;

//     let selection = $('.start-selection input[type=radio]:checked').val();
//     const $errMsg = $('.start.section-wrapper .error')
//     const $nextForm = $(`#${selection}-form-1`);
//     if ( $nextForm.length === 0 ) return $errMsg.removeClass('hidden');
//     $nextForm.removeClass('hidden');
//     $('#start-form').addClass('hidden');
//     $errMsg.addClass('hidden');
// });

// $('#audit-button').on('click', function() {
//     let type =$(this).val();
//     $(`#${type}-form-1`).removeClass('hidden');
//     $('#start-form').addClass('hidden');
//     $('.start.section-wrapper .error').addClass('hidden');
// })

// NEXT BUTTTONS

// NEW WEBSITE
$('#newsite-form-1 .next').on('click touch keydown', function(e){
    // If enter/space key not pressed when a keyboard event, then ignore
    if (
        e.originalEvent instanceof KeyboardEvent
        && (e.key !== "Enter" && e.key !== " ")
    ) return;

    // GET INPUT VALUES
    const newCurrent = $('.newCurrent').val();
    const newReq = $('.newReq').val();
    const newServices = $('.newServices').val();
    const newTarget = $('.sellingTo:checked').val();
    const newBudget = $('.newBudget').val();

    // CHECK REQUIRED INPUT VALUES
    if(newReq == 0 || newServices == 0) {
        $('#newsite-form-1 .required').each(function() {
            if($(this).val() == 0) {
                $(this).siblings('.error').removeClass('hidden');
            }
        });
    } else {
        $('#newsite-form-1').addClass('hidden');
        $('#newsite-form-1 .error').addClass('hidden');
        $('#newsite-form-2').removeClass('hidden');
    }

    // PASS VALUES TO CF7 FORM
    $('#newsite-form-2 .new-website').attr('value', newCurrent);
    $('#newsite-form-2 .new-requirements').attr('value', newReq);
    $('#newsite-form-2 .new-selling').attr('value', newServices);
    $('#newsite-form-2 .new-target').attr('value', newTarget);
    $('#newsite-form-2 .new-budget').attr('value', newBudget);
});

//DIGITAL
$('#digital-form-1 input[type=checkbox].other').on('click', function(){
    const isPreviouslyChecked = $(this).is(':checked');
    $('#digital-form-1 .otherInput')[(isPreviouslyChecked ? 'remove' : 'add')+'Class']('hidden')
    if(!isPreviouslyChecked) $('.error.digital-choice').addClass('hidden');
});

$('#digital-form-1 .other').on('click touch', function(){
    if(!$(this).is(':checked')) {
        $('.error.digital-choice').addClass('hidden');
    }
});

$('#digital-form-1 .next').on('click touch keydown', function(e){
    // If enter/space key not pressed when a keyboard event, then ignore
    if (
        e.originalEvent instanceof KeyboardEvent
        && (e.key !== "Enter" && e.key !== " ")
    ) return;

    // GET INPUT VALUES
    let otherInput = $('#digital-form-1 .otherInput').val();
    let digitalCurrent = $('#digital-form-1 .digitalCurrent').val();
    let digitalRegion = $('#digital-form-1 input[type=radio]:checked').val();
    let digitalChoice = [];
    let validForm = true;
    $("#digital-form-1 input[type=checkbox]:checked").each(function(){
        digitalChoice.push($(this).val());
    });

    // CHECK REQUIRED INPUT VALUES
    if (digitalChoice.includes($('#digital-form-1 .other').val()) && !otherInput) {
        validForm = false;
        $('.error.digital-choice').removeClass('hidden');
    } else if ( digitalChoice.length === 0 ) {
        $('.error.digital-choice').removeClass('hidden');
        validForm = false;
    } else {
        $('.error.digital-choice').addClass('hidden');
    }
    if (digitalRegion) {
        $('.error.digital-region').addClass('hidden');
    } else {
        $('.error.digital-region').removeClass('hidden');
        validForm = false;
    }

    if (validForm) {
        $('#digital-form-1').addClass('hidden');
        $('#digital-form-2').removeClass('hidden');
        $('#digital-form-1 .error').addClass('hidden');
    }

    // PASS VALUES TO CF7 FORM
    $('#digital-form-2 .digital-current').attr('value', digitalCurrent);
    $('#digital-form-2 .digital-region').attr('value', digitalRegion);
    $('#digital-form-2 .digital-choice').attr('value', digitalChoice);
    $('#digital-form-2 .digital-other').attr('value', otherInput);

});

// SOCIAL
$('#social-form-1 .next').on('click touch keydown', function(e) {
    // If enter/space key not pressed when a keyboard event, then ignore
    if (
        e.originalEvent instanceof KeyboardEvent
        && (e.key !== "Enter" && e.key !== " ")
    ) return;

    const $form = $('#social-form-1');
    const $finalForm = $('#social-form-2');

    // GET INPUT VALUES
    const currentSite = $form.find('[name="social-current-site"]').val();
    const existingSocials = $form.find('[name="social-handles"]').val();
    const lookingFor = $form.find('[name="social-type"]:checked').val();
    const marketingTo = $form.find('[name="marketing-to"]:checked').val();

    // VALIDATE VALUES
    let validForm = true;
    if (!lookingFor) {
        validForm = false;
        $form.find('.social-type .error').show();
    }

    // IF VALID MOVE TO NEXT STEP
    if(validForm) {
        $form.addClass('hidden');
        $form.find('.error').addClass('hidden');
        $finalForm.removeClass('hidden');
    }

    // PASS VALUES TO CF7 FORM
    $finalForm.find('.social-current-site').attr('value', currentSite)
    $finalForm.find('.social-handles').attr('value', existingSocials)
    $finalForm.find('.social-type').attr('value', lookingFor)
    $finalForm.find('.social-marketing').attr('value', marketingTo)
})


// DEVELOPMENT TO EXISTING SITE
$('#development-form-1 .next').on('click touch keydown', function(e){
    // If enter/space key not pressed when a keyboard event, then ignore
    if (
        e.originalEvent instanceof KeyboardEvent
        && (e.key !== "Enter" && e.key !== " ")
    ) return;

    // GET INPUT VALUES
    let devCurrent = $('.devCurrent').val();
    let devHow = $('.devHow').val();
    let devBudget = $('.devBudget').val();

    // CHECK REQUIRED INPUT VALUES
    if(devCurrent == 0 || devHow == 0) {
        $('.development.question-section .required').each(function() {
            if($(this).val() == 0) {
                $(this).siblings('.error').removeClass('hidden');
            }
        });
    } else {
        $('#development-form-1').addClass('hidden');
        $('#development-form-1 .error').addClass('hidden');
        $('#development-form-2').removeClass('hidden');
    }

    // PASS VALUES TO CF7 FORM
    $('#development-form-2 .development-website').attr('value', devCurrent);
    $('#development-form-2 .development-help').attr('value', devHow);
    $('#development-form-2 .development-budget').attr('value', devBudget);
});




// BACK BUTTON HANDLER GENERATOR
function getPrevHandler(from, to) {
    return (e) => {
        // If enter/space key not pressed when a keyboard event, then ignore
        if (
            e.originalEvent instanceof KeyboardEvent
            && (e.key !== "Enter" && e.key !== " ")
        ) return;

        $(from).addClass('hidden');
        $(to).removeClass('hidden');
    }
}
// BACK BUTTON HANDLERS
$('.question-section .back').on('click touch keydown', getPrevHandler('.question-section', '#start-form'))
$('#audit-form-1 .back').on('click touch keydown', getPrevHandler('#audit-form-1', '#start-form'));
$('#other-form-1 .back').on('click touch keydown', getPrevHandler('#other-form-1', '#start-form'));
$('#social-form-2 .back').on('click touch keydown', getPrevHandler('#social-form-2', '#social-form-1'));
$('#development-form-2 .back').on('click touch keydown', getPrevHandler('#development-form-2', '#development-form-1'));
$('#newsite-form-2 .back').on('click touch keydown', getPrevHandler('#newsite-form-2', '#newsite-form-1'));
$('#digital-form-2 .back').on('click touch keydown', getPrevHandler('#digital-form-2', '#digital-form-1'));


// CLEAR ALL INPUT VALUES AND SELECTIONS ON CLOSE
$('.close-form').on('click touch', function(){
    $(document).off('click touch', closeOnClickAway);
    $('.sideform-content').removeClass('show');
    $('.sideform-color').removeClass('show');
    $('body').css('overflow','visible');
    setTimeout(function(){
        $('.reset').trigger('click');
        $('.sideform-content input[type=radio]').removeClass('checked');
        $('.sideform-content input[type=checkbox]').removeClass('checked');
        $('.sideform-content input[type=checkbox]').prop('checked', false);
        $('.sideform-content input[type=checkbox]').removeAttr('checked');
        $('.digital.question-section .otherInput').addClass('hidden');
        // $('.section-wrapper').addClass('hidden');
        // $('.section-wrapper.start').removeClass('hidden');
    }, 500);
});

$(document).on('ready', function () {
    var wpcf7Elm = document.querySelector( '.wpcf7' );
    wpcf7Elm.addEventListener( 'wpcf7submit', function( event ) {
        setTimeout(function() {
            $('.sideform-content .section-wrapper').animate({
                scrollTop: $(".wpcf7-response-output").offset().top - 100
            }, 500);
        }, 500);
    }, false );
});

})